module.exports = require("@wildboar/x500/src/lib/modules/AuthenticationFramework/CertificatePair.ta");